<template>
  <div style="padding: 0px 0px 20px 20px" class="table-container">
    <div style="width: 100%;" class="fl-wrap mg-tp-sm">
      <div class="search-item">
        <span class="span">{{title}}</span>
        <el-input clearable size="mini" style="width:300px;margin-right:15px" v-model="searchForm.name"  class="item" :placeholder="`请输入${title}`"></el-input>
      </div>
      <div v-if="type != 4" class="search-item">
        <span class="span">适用行业类型</span>
        <el-cascader
        size="mini"
        clearable
        v-model="searchForm.control_id"
        :options="industryOptions"
        ></el-cascader>
      </div>
      <div class="search-item">
        <span class="span">上传部门</span>
        <el-cascader
          size="mini"
          ref="departmentTree"
          :show-all-levels="false"
          v-model="searchForm.create_department"
          @change="change"
          :options="departmentData"
          :props="{ checkStrictly: true, label: 'name', value: 'id' }"
          clearable></el-cascader>
      </div>
      <div class="search-item">
        <span class="span">上传时间</span>
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="margin-right:15px;"
          size="mini"
          v-model="Daterange"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </div>
    </div>
    <div style="width: 100%;display: flex" class="fl-wrap mg-tp-sm">
      <el-button class="search-item" @click="reset" style="height:28px" size="mini" type="primary">重置</el-button>
      <el-button class="search-item" @click="refreshTable" style="height:28px" size="mini" type="primary">查询</el-button>
    </div>
    <div class="ruleform">
      <div style="" class="table">
        <div style="font-size: 18px;margin-bottom:10px;display:flex;align-items:center"></div>
      </div>
      <el-table
        :data="tableData"
        @select="select"
        @select-all="selectAll"
        @cell-dblclick="tableDbEdit"
        highlight-current-row
        @current-change="currentChange"
        v-loading="loading"
        style="color:#303133;width: 100%; margin-bottom: 10px"
        :header-cell-style="{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'}"
        border
        stripe>
        <el-table-column
          type="selection"
          v-if="selectType == 'multiple'"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          :label="title">
        </el-table-column>
        <el-table-column
          prop="count"
          label="检查项数"
          width="90">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="control_name"
          label="适用行业类型">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="create_department"
          label="上传部门">
          <template slot-scope="{row}">
            {{ row.create_department || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="is_default"
          label="是否在企业端展示">
          <template slot-scope="{row}">
            {{row.is_default == 1 ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          :formatter="row => row.create_time || '-'"
          prop="create_time"
          label="上传时间">
        </el-table-column>
        <el-table-column
          :formatter="row => row.update_date || '-'"
          prop="update_date"
          label="更新时间">
        </el-table-column>
      </el-table>
      <el-row style="width: 100%">
        <el-col :span="24">
          <div style="float:right;padding:10px">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  </template>

  <script>
  import {api} from '@/api/api'
  import { industryOptions } from "@/Util/commonOptions";
  import {controlNameMap} from '@/router/control'
  // import {tableMixins} from '@/mixins/qiboMixins'
  export default {
    props: {
      tableData: Array,
      totalCount: Number,
      title: String,
      selectType: String,
    },
    components: {
    },
    // mixins: [tableMixins],
    data () {
      return {
        industryOptions,
        loading: false,
        Daterange: '',
        searchForm: {
          name: null,
          control_id: null,
          create_department: null,
        },
        row: null,
        dialogVisible: false,
        pagination: true,
        currentPage: 1,
        departmentData: [],
        SelectionAll: {},
        SelectionTable: [],
        list:null,
      }
    },
    computed: {
    },
    mounted () {
      this.getDepartmentTreeList()
    },
    watch: {
    },
    methods: {
      handleNewParams () {
        let params = {
          control_ids: this.treeId || null,
          type: this.type
        }
        for (let key in this.searchForm) {
          if (this.searchForm[key]) {
            params[key] = this.searchForm[key]
          }
        }
        if (this.create_department === '') {
          this.create_department = null
        }
        if (this.Daterange) {
          params.begin_time = this.Daterange[0]
          params.end_time = this.Daterange[1]
        }
        if (params.control_id) {
          params.control_id = params.control_id[1]
        }
        return params
      },
      handleCurrentChange (val) {
        this.getCheckStandardList(val)
      },
      getCheckStandardList (currentPage) {
        let params = {
          page_index: 1,
          page_size: 10,
          control_ids: this.treeId,
          type: this.type
        }
        if(currentPage){
          params.page_index = currentPage
        }
        this.loading = true
        this.$http.post(
          api['getCheckTableDBList'],
          params
        ).then(response => {
          this.tableData = response.data.data
          if (this.selectType == 'multiple') {
            this.$nextTick(() => {
              this.checkSelect()
            })
          }
          this.totalCount = response.data.page_info.total_num
          this.loading = false
        }).catch((error) => {
          console.log(error)
        })
      },
      select (selection, row) {
        for (let key in this.SelectionAll) {
          if (key == row.id) {
            delete this.SelectionAll[key]
            this.SelectionTable = Object.values(this.SelectionAll)
            return
          }
        }
        this.SelectionAll[row.id] = row
        this.SelectionTable = Object.values(this.SelectionAll)
        this.$emit('addSelectionTable',this.SelectionTable)
      },
      selectAll (select) {
        for (let row of this.tableData) {
          if (select.length === 0) {
            delete this.SelectionAll[row.id]
          } else {
            this.SelectionAll[row.id] = row
          }
        }
        this.SelectionTable = Object.values(this.SelectionAll)
        this.$emit('addSelectionTable',this.SelectionTable)
      },
      currentChange (currentRow) {
        if (currentRow) {
          this.list = currentRow
        }
      },
      //双击事件
      tableDbEdit(row,col){
        if (this.selectType == 'select') {
          this.$emit('addList',this.list)
        }
      },
      refreshTable(){
        
      },
      reset(){
        for(let i in this.searchForm){
          this.searchForm[i] = null
        }
        this.Daterange = []
      },
      getDepartmentTreeList () {
        this.$http.post(api.getDepartmentTreeList, {}).then(res => {
          if (res.data.code == 0) {
            this.departmentData = res.data.data
            this.departmentData.forEach(v => {
              v.name = `${v.name}`
            })
          }
        })
      },
    }
  }
  </script>

  <style scoped>
  .fl-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .mg-tp-sm {
    margin-top: 8px;
  }
  .span {
    margin: 8px;
  }
  .search-item {
    margin: 10px 10px 10px 0;
  }
  </style>



// WEBPACK FOOTER //
// src/components/selectCheckList/table1.vue